import axios from 'axios'

export const wishlist = {
    state:{
        WishListDetails:{},
        WishListUrl: ''
    },
    mutations:{
        WishListDetails(state,data){
            state.WishListDetails = data
            
        },
        WishListUrl(state,url){
            state.WishListUrl = url
            
        },
    },
    actions:{
        CreateOffer: ({commit}, payload) => {
            const url = payload.wishlistUrl
            return new Promise((resolve, reject)=>{
            axios.post("/getwishlistdetails",payload)
            .then(({data, status})=>{
                if(status === 200){
                console.log(data)
                commit('WishListDetails', data)
                commit('WishListUrl', url)
                resolve(data);
                }
            })
            .catch((error)=>{
                reject(error);
            });
            })
        },
        
      
     }
}